import Immutable from 'immutable'
import parse from 'parse-link-header'

import {
  QC_FETCH_RECORDS,
  QC_FETCH_RECORDS_SUCCESS,
  QC_FETCH_RECORDS_FAILURE,
} from '../../actions/qc/types'
import { ADMIN_SCAN_VALID_SUCCESS } from '../../actions/admin'

const reducers = {
  [QC_FETCH_RECORDS]: (state) => {
    return state.set('loading', true)
  },

  [QC_FETCH_RECORDS_SUCCESS]: (state, action) => {
    const pageInfo = parse(action.payload.headers.link)
    return state
      .set('scanRecords', Immutable.fromJS(action.payload.data))
      .set('pageInfo', Immutable.fromJS(pageInfo))
      .set('loading', false)
  },

  [QC_FETCH_RECORDS_FAILURE]: (state) => {
    return state.set('loading', false)
  },

  [ADMIN_SCAN_VALID_SUCCESS]: (state, action) => {
    const { id, scanValid } = action.payload.data
    const index = state
      .get('scanRecords')
      .findIndex((item) => item.get('id') === id)
    const updatedList = state
      .get('scanRecords')
      .update(index, (item) => item.set('scanValid', scanValid))

    return state.set('scanRecords', updatedList)
  },
}

const defaultState = new Immutable.Map({ loading: false })

export default function (state = defaultState, action) {
  if (action && typeof reducers[action.type] === 'function') {
    return reducers[action.type](state, action)
  }

  return state
}
